import { render, staticRenderFns } from "./TabContractAnnexInfoPreview.view.vue?vue&type=template&id=56403954&"
import script from "./TabContractAnnexInfoPreview.view.vue?vue&type=script&lang=js&"
export * from "./TabContractAnnexInfoPreview.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56403954')) {
      api.createRecord('56403954', component.options)
    } else {
      api.reload('56403954', component.options)
    }
    module.hot.accept("./TabContractAnnexInfoPreview.view.vue?vue&type=template&id=56403954&", function () {
      api.rerender('56403954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/annex/sign/TabContractAnnexInfoPreview.view.vue"
export default component.exports